/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TagRequest, TagTypeResponse } from '../../../page-modules/playlist/models';
import { ResourceTag } from '../../models';
import { FrameworkCategoriesTree } from '../../models/admin/admin.model';
import { Page } from '../../models/page';
import { FrameworkTrackerSectionTag } from '../../models/page/page.model';
import { EscoSkill } from '../../models/skill.model';
import { ObservableResult } from '../../store';
import { MultiTagCreationRequest, TagDataService, TagInfo } from './tag-data.service';

@Injectable()
export class MockTagDataService implements TagDataService {
  private tag: ResourceTag = { _id: 'tagId', title: 'AWS' };

  createTag(request: TagRequest): ObservableResult<ResourceTag> {
    return ObservableResult.ofSuccess(this.tag);
  }

  createTags(request: MultiTagCreationRequest): ObservableResult<ResourceTag[]> {
    return ObservableResult.ofSuccess([this.tag]);
  }

  findTagsWithTitleTerm(text: string): ObservableResult<ResourceTag[]> {
    return ObservableResult.ofSuccess([this.tag]);
  }

  findLtiTagsWithTitleTerm(organizationUid: string, requestId: string | null, text: string): ObservableResult<ResourceTag[]> {
    return ObservableResult.ofSuccess([this.tag]);
  }

  extractTags(text: string): ObservableResult<string[]> {
    return ObservableResult.ofSuccess(['tag1', 'tag2']);
  }

  getTraitTags(page: number, size: number): ObservableResult<TagTypeResponse[]> {
    return ObservableResult.ofSuccess();
  }

  getTeamRoleTags(page: number, size: number): ObservableResult<TagTypeResponse[]> {
    return ObservableResult.ofSuccess();
  }

  getJungianTypeTags(page: number, size: number): ObservableResult<TagTypeResponse[]> {
    return ObservableResult.ofSuccess();
  }

  getBigSixTags(page: number, size: number): ObservableResult<TagTypeResponse[]> {
    return ObservableResult.ofSuccess();
  }

  findCategoriesWithTitleTerm(text: string): ObservableResult<ResourceTag[]> {
    return ObservableResult.ofSuccess();
  }

  createCategory(request: TagRequest): ObservableResult<ResourceTag> {
    return ObservableResult.ofSuccess();
  }

  findCategories(categoriesUid: string[]): ObservableResult<TagInfo[]> {
    return ObservableResult.ofSuccess();
  }

  getCategoriesTree(): ObservableResult<FrameworkCategoriesTree[]> {
    return ObservableResult.ofSuccess([]);
  }

  getSkillScores(page?: number, size?: number): ObservableResult<Page<FrameworkTrackerSectionTag>> {
    return ObservableResult.ofSuccess();
  }

  searchEscoSkills(term: string, page?: number, size?: number): ObservableResult<Page<EscoSkill>> {
    return ObservableResult.ofSuccess({ content: [], totalNumberOfElement: 0, pageSize: 20, currentPageNumber: 0 });
  }

  resolveEscoConcepts(conceptUris: string[]): ObservableResult<EscoSkill[]> {
    return ObservableResult.ofSuccess([]);
  }

  getSkillScoresCount(): Observable<number> {
    return of(0);
  }
}
